import React,{useState,useEffect} from 'react';
import { useSelector, useDispatch} from 'react-redux';
import {setNavRouteData} from "../../redux/actions/mapaction"
import axios from 'axios';
export function GetRouteApi(){
const dispatch = useDispatch()
const startcords = useSelector(state => state.mapreducer.startcord)
const endcoords = useSelector(state => state.mapreducer.mapcentrecord)
// console.log(navdata)
  // const dispatch = useDispatch()
    const [result, setResult] = useState({
        loading:false,
        route: {},
        error: '',
    });
    useEffect(() => {
      const getData = async () => {
        setResult({...result,
        loading:true})
        const arr = {
          route: [],
          duration:'',
          distance:'',
          steps: []
        };
        await axios.get(`https://api.mapbox.com/directions/v5/mapbox/driving/${startcords.longitude},${startcords.latitude};${endcoords.longitude},${endcoords.latitude}?steps=true&geometries=geojson&access_token=${process.env.REACT_APP_MAPBOX_TOEKN}`,
        {
            headers: {
                'content-type': 'application/json',
                'Access-Control-Allow-Origin' : '*'}
        },
            ).then((res) => {
          let data =  res.data.routes[0];
          arr.route =  data.geometry.coordinates
          arr.duration = data.duration
          arr.distance = data.distance
          arr.steps = data.legs[0].steps
          setResult({
            ...result,
            loading:false,
            route: arr
          })
          dispatch(setNavRouteData(arr))

        })
        .catch(error => {
            setResult({...result,
              loading:false,
              error: error
            })
           });
        }
      getData();
    }, [startcords,endcoords]);
    return (result)
}